import styled from "styled-components";
import BasicForm from "./BasicForm";
import AddressForm from "./AdressForm";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getOperatorClientsById } from "../../../services/clients/getById";
import { GetOperatorClientsById } from "../../../services/clients/getById/types";
import { LoadingBackDrop } from "../../../components/loader";
import { createTheme, Tab, Tabs, TabsProps } from "@mui/material";
import { theme } from "../../../helpers/theme";
import { GoBackButton } from "../../../components/GoBackButton";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      className="tabPanel"
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
};

export const OperatorClientsEdit = () => {
  const { id } = useParams();

  const [operatorClient, setOperatorClient] = useState<
    GetOperatorClientsById[]
  >([]);

  const body = {
    paginacja: null,
    filtr: {
      id_klient: id,
    },
  };

  const GetOperatorClientsById = useQuery(
    ["AllOperatorClients"],
    () => getOperatorClientsById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setOperatorClient(data.data.payload.klienci);
        setValue(0);
      },
    }
  );

  const [value, setValue] = useState(1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (GetOperatorClientsById.isLoading || GetOperatorClientsById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <FormWrapper>
        {/* <ButtonWrapper> */}
        <Tabs
          sx={{
            width: "70%",
          }}
          centered
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Dane Podstawowe" />
          <Tab label="Adres" />
        </Tabs>
        {/* </ButtonWrapper> */}

        <TabPanel value={value} index={0}>
          <BasicForm
            clientData={operatorClient}
            setOperatorClient={setOperatorClient}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddressForm {...operatorClient} />
        </TabPanel>
      </FormWrapper>
    </>
  );
};

export default OperatorClientsEdit;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  // padding: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }

  .tabPanel {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
